import {
  IPrivateChannel,
  IStreamChannel,
} from '@core/chat/StreamChat/interfaces';

export const checkIsStreamChannelUnread = (
  streamChannel: IStreamChannel | null,
): boolean => {
  if (!streamChannel) return false;

  const lastReadDate = streamChannel.lastRead();
  const unreadCount = streamChannel.countUnread(lastReadDate);

  return !!unreadCount;
};

export const checkHasUnreadPrivateChannel = (
  privateChannels: IPrivateChannel[],
): boolean => {
  const hasUnreadPrivateChannel = privateChannels
    .map((privateChannel) => privateChannel.channel)
    .some((channel) => checkIsStreamChannelUnread(channel));

  return hasUnreadPrivateChannel;
};
